import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1283641707274805';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
function initFacebookPixel() {
  if (typeof window === 'undefined') return;
  // If already initialized, just fire PageView again
  if (window.fbq) {
    try {
      window.fbq('track', 'PageView');
    } catch (e) {
      console.warn('fbq PageView error', e);
    }
    return;
  }
  // Build the fbq queue directly on window (replicates the official Facebook snippet)
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  // Load the Facebook events script
  if (!document.getElementById('facebook-pixel-script')) {
    const script = document.createElement('script');
    script.id = 'facebook-pixel-script';
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }
  // Initialize and track PageView immediately — these calls queue
  // until fbevents.js finishes loading, then are processed in order.
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
  // Add the noscript fallback image
  if (!document.getElementById('facebook-pixel-noscript')) {
    const noscript = document.createElement('noscript');
    noscript.id = 'facebook-pixel-noscript';
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }
}
export function MetaPixel() {
  useEffect(() => {
    initFacebookPixel();
  }, []);
  return null;
}
export function trackAddToCart(data?: {
  value?: number;
  currency?: string;
  content_name?: string;
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'AddToCart', data);
    } catch (e) {
      console.warn('fbq AddToCart error', e);
    }
  }
}